import { render } from "./detail-view.vue?vue&type=template&id=06432a01&scoped=true"
import script from "./detail-view.vue?vue&type=script&lang=js"
export * from "./detail-view.vue?vue&type=script&lang=js"

import "./detail-view.vue?vue&type=style&index=0&id=06432a01&lang=scss&scoped=true"
import "./detail-view.vue?vue&type=style&index=1&id=06432a01&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06432a01"]])

export default __exports__